<template>
  <div class="message__container" :class="`message__role-${message.role}`">
    <div class="message__avatar">
      <AssistantLogo width="20" height="20" fill="white" v-if="message.role === 'assistant'" />
      <UserLogo width="20" height="20" fill="black" v-else-if="message.role === 'user'" />
    </div>

    <div class="message__content">
      <div class="message__body">
        <template v-if="message.body">{{ message.body }}</template>
        <div class="flex" v-else>
          <BeatLoader :color="'#999'"  />
        </div>
      </div>
      <div class="message__timestamp">{{ formattedTimestamp }}</div>
    </div>
  </div>
</template>

<script>
import AssistantLogo from "./assets/assistant_logo.vue"
import UserLogo from "./assets/user_logo.vue"

import { BeatLoader } from "vue3-spinner"

export default {
  name: "Message",

  components: {
    AssistantLogo,
    UserLogo,
    BeatLoader
  },

  props: {
    message: Object
  },

  computed: {
    formattedTimestamp() {
      return this.message.timestamp ? new Date(this.message.timestamp).toLocaleString() : ""
    }
  }
}
</script>

<style scoped>
.message__container {
  display: flex;
  gap: 8px;
}

.message__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: relative;
  top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.message__role-user .message__avatar {
  background-color: rgba(0, 0, 0, 0.05);
}

.message__role-assistant .message__avatar {
  background-color: #75a99c;
}

.message__content {
  flex: 1;
  min-height: 40px;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.05);
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
}

.message__body {
  flex: auto;
}

.message__timestamp {
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: small;
  color: grey;
}
</style>
